import React, { FocusEvent } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import Icon from '../../../../@shared/icon';
import { iconSize } from '../../../../../constants/icon.constants';

const GdprConsentCheckbox = (props) => {
  const { field, tracker, label, value, hasAnyError, id } = props;

  const onFocus = (e: FocusEvent<HTMLInputElement>): void => {
    tracker.onFocusField(field, e?.target?.value);
  };

  const onBlur = (e: FocusEvent<HTMLInputElement>): void => {
    tracker.onBlurField(field, e?.target?.value);
  };

  const onChange = (): void => {
    props.onChange(!value);
  };

  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--checkboxfield ${
        hasAnyError && !value ? 'sitecore-jss-form__control--has-error' : ''
      }`}
    >
      <input
        aria-label= {label}
        className="sitecore-jss-form__field"
        onFocus={onFocus}
        onBlur={onBlur}
        type="checkbox"
        onChange={onChange}
        value={value}
        checked={value}
        form="novalidatedform"
      />

      <label htmlFor={id} className="sitecore-jss-form__control__label--checkbox-label">
        <Icon
          iconName={value ? 'action-checkbox-checked' : 'action-checkbox-default'}
          size={iconSize.dsk}
          extraClassName="sitecore-jss-form__checkbox"
          onClick={onChange}
        />
        <RichText tag="div" field={{ value: label }} className="rich-text" />
      </label>
    </div>
  );
};

export default GdprConsentCheckbox;
